import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTrending5"><Path fillRule="evenodd" clipRule="evenodd" d="M5 3V14.5858L9.5 10.0858L12 12.5858L17 7.58579L20.4142 11L19 12.4142L17 10.4142L12 15.4142L9.5 12.9142L5 17.4142V19H21V21H3V3H5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrending5;
